import { useQuery, queryOptions } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/api-clients/react-query';
import { publicApi } from '@/lib/api-clients/rest-client';

export interface CapitalPlan {
  productId: string;
  name: string;
  description: string;
  priceId: string;
  currency: string;
  unitAmount: number;
  unitAmountDecimal: string;
  priceType: string;
  metadata: {
    account_size: string;
    dec: string;
    max_daily_loss: string;
    max_drawdown: string;
    max_leverage: string;
    max_profit_split: string;
    step_1_goal: string;
  };
}

export interface CapitalPlansResponse {
  products: CapitalPlan[];
}

// const STALE_TIME = 5 * 60 * 1000; // 5 minutes

export function fetchCapitalPlans(): Promise<CapitalPlan[]> {
  return publicApi
    .get<CapitalPlansResponse>('/capital/plans', {
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true',
      },
    })
    .then((data) =>
      data.products.filter(
        (plan) => plan.metadata.account_size !== '5000000', // TEMP: remove after new plan is added
      ),
    );
}

export const getCapitalPlansQueryOptions = () => {
  return queryOptions({
    queryKey: ['capital-plans'],
    queryFn: () => fetchCapitalPlans(),
    // staleTime: STALE_TIME,
  });
};

type UseCapitalPlansOptions = {
  queryConfig?: QueryConfig<typeof getCapitalPlansQueryOptions>;
};

export const useCapitalPlans = ({
  queryConfig,
}: UseCapitalPlansOptions = {}) => {
  const result = useQuery({
    ...getCapitalPlansQueryOptions(),
    ...queryConfig,
  });

  return result;
};
